import { render, staticRenderFns } from "./Specs.vue?vue&type=template&id=dbad1a62&scoped=true"
import script from "./Specs.vue?vue&type=script&lang=js"
export * from "./Specs.vue?vue&type=script&lang=js"
import style0 from "./Specs.vue?vue&type=style&index=0&id=dbad1a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbad1a62",
  null
  
)

export default component.exports